// Utility function to normalize classes to arrays
export const normalizeClasses = (classes) => {
  if (!classes) return []
  if (Array.isArray(classes)) return classes
  if (typeof classes === 'string') return classes.split(' ').filter(Boolean)
  if (typeof classes === 'object') {
    return Object.entries(classes)
      .filter(([, value]) => value)
      .map(([key]) => key)
  }
  return []
}

// Utility function to merge attributes properly, combining classes instead of overwriting
export const mergeAttrs = (commonAttrs, userAttrs) => {
  const { class: userClass, ...otherUserAttrs } = userAttrs
  const { class: commonClass, ...commonOtherAttrs } = commonAttrs

  const mergedClasses = [
    ...normalizeClasses(commonClass),
    ...normalizeClasses(userClass),
  ]

  return {
    ...commonOtherAttrs,
    ...otherUserAttrs,
    class: mergedClasses.length > 0 ? mergedClasses : undefined,
  }
}
